module.exports = __webpack_public_path__ + "static/media/female_child.37ce7f74.svg";